// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".OrderNote_wrapper__3Dqz3 {\n  display: flex;\n  flex-direction: column;\n  grid-gap: 16px;\n  gap: 16px;\n  margin-bottom: 36px; }\n  .OrderNote_wrapper__3Dqz3 h2 {\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 28px;\n    margin: 0;\n    color: #494949; }\n  .OrderNote_wrapper__3Dqz3 textarea {\n    min-height: 90px; }\n  .OrderNote_wrapper__3Dqz3 .OrderNote_footer__1r7ZD {\n    display: flex;\n    justify-content: flex-end;\n    grid-gap: 8px;\n    gap: 8px; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "OrderNote_wrapper__3Dqz3",
	"footer": "OrderNote_footer__1r7ZD"
};
module.exports = exports;
